<template>
  <v-lazy :min-height="335" :options="{ threshold: 0.5 }" transition="fade">
    <v-row>
      <v-col>
        <a :href="hrefLink">
          <v-img :id="id" contain :src="img" :alt="name" :aspect-ratio="$vuetify.breakpoint.xs ? 1 : 2.5">
            <template v-slot:placeholder>
              <v-sheet color="#EFEFEF" class="fill-height"></v-sheet>
            </template>
          </v-img>
        </a>
        <div class="mt-2 mt-md-0 mb-1">
          <a :href="hrefLink">
            <span class="text-uppercase text-tcdc-green sub-header1 bold" style="text-decoration: none">
              <!-- {{ name }} -->
              <span v-html="name"></span>
            </span>
          </a>
        </div>
        <Divider />


        <v-layout justify-space-between style="padding: 6px 0;">
          <v-flex shrink class="text-tcdc-green overflow-hidden" style="max-width: 60%">
            <div class="d-flex flex-1 align-center fill-height text-no-wrap">
              <img src="../../assets/icons/sorts/calendar.png" class="eventcard-logo pr-3" alt="event-date"
                style="width: 41px;" />



              <div v-if="event_date" class="bold overflow-hidden events_date">
                <!-- <div v-if="event_date" class="bold overflow-hidden" style="text-overflow: ellipsis"> -->

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{ event_date }}</span>
                  </template>
                  <span>{{ event_date }}</span>
                </v-tooltip>

              </div>
              <div v-else class="bold overflow-hidden" style="text-overflow: ellipsis">
                <span v-if="time_start.split(' ')[2] === time_end.split(' ')[2]" class="bold overflow-hidden"
                  style="text-overflow: ellipsis">
                  {{ time_start.split(' ')[0] + ' ' + time_start.split(' ')[1] }} - <br v-if="$vuetify.breakpoint.xs">
                  {{
    time_end }}
                </span>
                <span v-else class="bold overflow-hidden" style="text-overflow: ellipsis">
                  {{ time_start }} - <br v-if="$vuetify.breakpoint.xs"> {{ time_end }}
                </span>
              </div>

            </div>
          </v-flex>

          <!-- <v-flex shrink class="text-end overflow-hidden"
            :style="{ 'max-width': $vuetify.breakpoint.smAndDown ? '50%' : '40%' }">
            <div class="d-flex flex-1 align-center fill-height events_loc">
              <img src="../../assets/icons/marker.png" class="eventcard-logo" alt="event-source" style="width: 30px;" />
              <span class="text-tcdc-green bold overflow-hidden" style="text-overflow: ellipsis">{{ place }}</span>
            </div>
          </v-flex> -->

          <!-- <v-flex shrink class="text-tcdc-green" style="max-width: 60%"> -->
          <v-flex shrink class="text-tcdc-green text-end overflow-hidden"
            :style="{ 'max-width': $vuetify.breakpoint.smAndDown ? '50%' : '40%' }">
            <div class="d-flex flex-1 align-center fill-height text-wrap ">

              <img src="../../assets/icons/marker.png" class="eventcard-logo" alt="event-source" style="width: 30px;" />

              <div class="bold ">
                <span class="bold ">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{ place }}</span>
                    </template>
                    <span class="showTooltip">{{ place }}</span>
                  </v-tooltip>
                </span>
              </div>

            </div>
          </v-flex>

        </v-layout>
        <Divider />
      </v-col>
    </v-row>
  </v-lazy>
</template>

<script>
import Divider from "../../components/dividers/Divider";
export default {
  props: {
    name: {
      type: String,
      default: ""
    },
    time_start: {
      type: String,
      default: ""
    },
    time_end: {
      type: String,
      default: ""
    },
    place: {
      type: String,
      default: ""
    },
    id: {
      type: Number,
      default: 1
    },
    img: {
      type: String,
      default: ''
    },
    hrefLink: {
      default: '#'
    },
    event_date: {
      type: String,
      default: ""
    },
  },
  components: {
    Divider
  }
};
</script>

<style scoped>
.eventcard-logo {
  height: 25px;
  object-fit: contain;
}

.events_date,
.events_loc {
  text-overflow: ellipsis;
}

@media (max-width: 600px) {
  .events_date {
    display: -webkit-box;
    max-width: 150px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .events_loc {
    display: -webkit-box;
    max-width: 100px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  .showTooltip {
    width: auto;
  }
}
</style>
